module.exports = __webpack_public_path__ + "static/media/IMG_4312.7a0a8b48.JPG";